import { Axios } from "../lib/axios";

export const SearchServices = {
  postReindexContent,
  postReindexFilesContent,
  getJobsList,
  flushQueues,
  searchTrendsData,
};

function postReindexContent() {
  return Axios.post(`/createReindexJob`);
}

function postReindexFilesContent() {
  return Axios.post(`/createReindexJobForFiles`);
}

function flushQueues() {
  return Axios.post(`/flushQueueJobList`);
}

function getJobsList() {
  return Axios.post(`/getQueueJobList`);
}

function searchTrendsData(queryParams) {
  return Axios.get(`/openSearch/trends?${queryParams}`);
}
